export default function Footer() {
    return <div className="app-footer"/>;
}
